/* Naar Halı: teknik özellik açıklamaları (23 Eki 2026)

   NEDEN: Ürün Detayları sekmesindeki "Hav Yüksekliği", "İplik Türü", "Dokuma Sıklığı", "Taban Tipi" gibi satırları
   müşteriler bilmiyor ("polyester mi ipek mi daha iyi?", "480.000 point ne demek?"). Her satıra dokununca/tıklayınca
   o özelliği, hangi değerin ne anlama geldiğini ve nasıl seçileceğini anlatan bir açıklama penceresi açılır.

   NASIL ÇALIŞIR: Satırlar ürünün KENDİ açıklamasından gelir (değişmez); bu betik yalnızca satırı düğmeye çevirir ve
   etikete ("Hav Yüksekliği") ve değere ("8 mm", "%50 Akrilik, %50 Viskon") göre aşağıdaki açıklamaları gösterir.
   Eşleşen açıklama yoksa satır eskisi gibi düz yazı kalır. Metinler genel bilgidir: ürüne özgü iddia içermez.
   Açıklamaları değiştirmek için bu dosyadaki ALANLAR ve DEGERLER bölümlerini düzenleyin. */
(function () {
  'use strict';

  /* ---------------- Açıklama metinleri ---------------- */

  // Alan açıklamaları. anahtar: etiketin küçük harfli hâli
  var ALANLAR = {
    hav: {
      etiketler: ['hav yüksekliği'],
      ad: 'Hav yüksekliği',
      nedir: 'Halının yüzeyindeki ipliklerin (ilmek ya da tüylerin), taban dokunun üzerinden ne kadar yükseldiğini milimetre olarak gösterir. Halıya bastığınızda hissettiğiniz kabarıklık budur.',
      baslik: 'Hangi hav size uygun?',
      gruplar: [
        { id: 'kisa', b: 'Kısa hav · yaklaşık 10 mm\'ye kadar', m: 'Yüzey düz ve ince. Süpürmesi kolaydır, robot süpürge genellikle rahat geçer, kapı altında takılmaz. Sık kullanılan salon, koridor ve mutfak için pratiktir.' },
        { id: 'orta', b: 'Orta hav · yaklaşık 10–20 mm', m: 'Daha dolgun ve yumuşak bir his verir. Toz ve kırıntıyı biraz daha çok tutar, düzenli süpürme ister.' },
        { id: 'uzun', b: 'Uzun hav · 20 mm üzeri', m: 'Çok yumuşak ve tüylü görünür. Daha sık ve dikkatli bakım gerekir; robot süpürge ve kapı altı için uygun olmayabilir.' }
      ],
      dipnot: 'Bu sınırlar sektörde yaygın kullanılan yaklaşık değerlerdir; üreticiye göre değişebilir.'
    },
    kalinlik: {
      etiketler: ['halı kalınlığı', 'kalınlığı'],
      ad: 'Halı kalınlığı',
      nedir: 'Halının hav ve taban dahil toplam kalınlığıdır.',
      maddeler: [
        { b: 'İnce halı', m: 'Kapı altında sıkışmaz, katlaması ve taşıması kolaydır, süpürmesi pratiktir.' },
        { b: 'Kalın halı', m: 'Daha dolgun ve ayak altında daha yumuşaktır; kapı altı payına ve robot süpürge geçişine dikkat etmek gerekir.' }
      ]
    },
    iplik: {
      etiketler: ['iplik türü', 'malzeme'],
      ad: 'İplik türü',
      nedir: 'Halının yüzeyini oluşturan ipliğin hammaddesidir. Dokunuşu, parlaklığı, dayanıklılığı, temizlik kolaylığını ve fiyatı en çok bu belirler.',
      baslik: 'Hangisi daha iyi?',
      giris: 'Herkes için tek bir "en iyi" iplik yok; kullanım yerine göre seçilir:',
      maddeler: [
        { b: 'Yoğun kullanım, çocuk, evcil hayvan, kolay temizlik', m: 'Polyester, akrilik ve yün iyi seçimlerdir.' },
        { b: 'Yumuşak ve sıcak his', m: 'Akrilik, şönil ve yün.' },
        { b: 'İpeksi parlaklık ve şık görünüm', m: 'İpek, viskon, modal ve bambu. Bunlar neme ve ağır kullanıma karşı daha hassastır, özenle kullanılmalıdır.' },
        { b: 'Uzun yıllar kullanım', m: 'Yün (özellikle el dokuma) çok uzun ömürlüdür.' }
      ],
      dipnot: 'Polyester mi ipek mi? İpek doğal, çok ince ve değerlidir ama hassastır; polyester dayanıklı ve pratiktir. Hareketli bir salon için polyester ya da yün, az kullanılan şık bir oda için ipek ya da viskon daha mantıklıdır.'
    },
    siklik: {
      etiketler: ['dokuma sıklığı'],
      ad: 'Dokuma sıklığı',
      nedir: 'Bir metrekare halıda kaç düğüm ya da ilmek noktası (point) bulunduğunu gösterir. Sayı büyüdükçe iplikler daha sık dizilir.',
      baslik: 'Neden önemli?',
      maddeler: [
        { b: 'Sık dokuma', m: 'Desen daha net ve ince detaylı çıkar, yüzey daha sıkı ve sağlam olur, kolay ezilmez.' },
        { b: 'Seyrek dokuma', m: 'Daha hafif ve esnek bir yapı verir; desen daha iri hatlarla işlenir.' }
      ],
      dipnot: 'Tek başına bir kalite ölçüsü değildir: iplik türü, hav yüksekliği ve üretim yöntemiyle birlikte değerlendirilir. El dokuma ile makine halılarında point aynı yöntemle sayılmadığı için farklı üretim türlerinin sayılarını doğrudan kıyaslamayın.'
    },
    taban: {
      etiketler: ['taban tipi', 'alt yüzey'],
      ad: 'Taban tipi',
      nedir: 'Halının zemine değen arka katmanıdır; halının iskeletini oluşturur. Halının düz durmasını, formunu korumasını ve zeminde nasıl davrandığını belirler.',
      baslik: 'Taban neden önemli?',
      maddeler: [
        { b: 'Dengeli durur', m: 'Sağlam bir taban halının kenarlarının kıvrılmasını ve dalgalanmasını azaltır.' },
        { b: 'Zeminde tutunur', m: 'Kaymaz özelliği belirtilen tabanlar halının yerinde durmasına yardım eder. Kaymaz özelliği olmayan halılarda ayrıca kaymaz alt ped kullanabilirsiniz.' }
      ]
    },
    dokuma: {
      etiketler: ['dokuma tipi', 'üretim tipi'],
      ad: 'Dokuma tipi',
      nedir: 'Halının nasıl üretildiğini gösterir: makine tezgâhında mı, el emeğiyle mi.',
      baslik: 'Fark nedir?',
      maddeler: [
        { b: 'Makine dokuma', m: 'Düzgün, sık ve her parçası birbirinin aynı olan halılar; üretimi hızlıdır, fiyatı daha ulaşılabilirdir.' },
        { b: 'El dokuma', m: 'Usta dokumacıların ilmek ilmek işlediği halılar; her biri birazcık farklıdır, çok uzun ömürlüdür, fiyatı daha yüksektir.' }
      ]
    },
    sacak: {
      etiketler: ['saçak tipi'],
      ad: 'Saçak tipi',
      nedir: 'Halının iki kısa kenarındaki ip uzantılarıdır; hem süs hem de dokunun çözülmemesini sağlayan bitiş detayıdır. Saçaksız halılarda kenar dikişle kapatılır.',
      baslik: 'Hangisi size uygun?',
      maddeler: [
        { b: 'Saçaklı', m: 'Klasik ve zarif görünür; saçakları ara sıra tarayıp düzeltmek ve süpürgeyi saçağın üstüne geçirmemek gerekir.' },
        { b: 'Saçaksız / kenar dikişli', m: 'Daha sade ve modern görünür; takılma riski yoktur, robot süpürge ve kapı geçişleri için pratiktir.' }
      ]
    },
    ebat: {
      etiketler: ['ebat / boyut', 'ebat/boyut'],
      ad: 'Ebat / boyut',
      nedir: 'Halının genişlik × uzunluk ölçüsüdür (santimetre). Örneğin 80x150, 80 cm genişlik ve 150 cm uzunluk demektir.',
      baslik: 'Seçerken',
      maddeler: [
        { b: 'Yerinde deneyin', m: 'Halıyı koymak istediğiniz yeri bant ya da gazeteyle işaretleyip ölçüyü gözünüzle görün.' },
        { b: 'Küçük sapma olabilir', m: 'Üretim sürecinin doğası gereği ölçülerde %5\'e kadar fark olabilir.' }
      ]
    },
    ozel: {
      etiketler: ['özel ölçü'],
      ad: 'Özel ölçü',
      nedir: 'Halının istenen ölçüde hazırlanıp hazırlanamayacağını gösterir. "Uygulanmaz" yazıyorsa bu halıda ölçü değiştirilemez; sayfadaki hazır ölçülerden biri seçilir.'
    },
    yer: {
      etiketler: ['üretim yeri'],
      ad: 'Üretim yeri',
      nedir: 'Halının üretildiği ülkeyi gösterir. Her ülkenin kendine özgü bir dokuma geleneği vardır. Ülke tek başına kaliteyi belirlemez; iplik, dokuma ve sıklık birlikte değerlendirilir.'
    },
    renk: {
      etiketler: ['renk'],
      ad: 'Renk',
      nedir: 'Ürün görsellerindeki ışık ve çekim açıları renk tonlarında küçük farklılıklara neden olabilir; ekran ayarları da etkiler. Rengi mutlaka odanızın ışığında düşünün.'
    }
  };

  // Değer açıklamaları: anahtar sözcüklerden biri değerde geçerse kart gösterilir (küçük harfle aranır)
  var DEGERLER = {
    iplik: [
      { k: ['karışım', '%', ' - ', ', ', ' ve '], oz: 'karisim', ad: 'Karışım nasıl okunur?', m: 'Karışım iplikli halılarda iki ya da daha fazla lif birlikte eğrilir. Yüzdesi yüksek olan lifin özelliği daha belirgindir; örneğin %90 yün + %10 ipekte yünün dayanıklılığı ipeğin parlaklığıyla birleşir. Amaç genelde bir lifin eksiğini diğeriyle dengelemektir (ör. parlaklık + dayanım, yumuşaklık + uygun fiyat).' },
      { k: ['polyester', 'polip'], ad: 'Polyester', m: 'Dayanıklı, pratik bir sentetik liftir. Mikro polyester çok ince liflerden yapıldığı için daha yumuşak dokunur.', arti: ['Leke ve neme dayanıklıdır, temizliği kolaydır', 'Renklerini iyi korur', 'Uygun fiyatlıdır'], dikkat: ['Yüksek ısıya (ütü, soba önü) dayanmaz', 'Yün ve ipek gibi doğal lifler kadar "nefes almaz"'] },
      { k: ['şönil'], ad: 'Şönil', m: 'Kadife benzeri, tüylü ve çok yumuşak bir iplik çeşididir; halıya sıcak ve dolgun bir his verir.', arti: ['Yumuşak ve rahat bir dokunuş'], dikkat: ['Yüzeyi tüylü olduğu için düzenli süpürmek gerekir'] },
      { k: ['akrilik'], ad: 'Akrilik', m: 'Yüne benzeyen yumuşak ve sıcak hisli bir sentetik liftir.', arti: ['Yün gibi sıcak his, daha hafif ve uygun fiyatlı', 'Güneşte renk solması az, leke tutmaması kolay temizlik sağlar'], dikkat: ['Yün kadar esnek değildir', 'Yüksek ısıya karşı hassastır; uzun süre kullanımla yüzeyde hafif topaklanma olabilir'] },
      { k: ['yün'], ad: 'Yün', m: 'Doğal ve hayvansal bir liftir; halıcılığın en köklü ipliğidir.', arti: ['Çok dayanıklı ve esnektir; ezildikten sonra toparlar', 'Isı yalıtımı iyidir, kışın sıcak tutar', 'Uzun yıllar kullanılır'], dikkat: ['İlk aylarda hafif tüy bırakması normaldir', 'Neme ve güveye karşı korunmalıdır', 'Fiyatı sentetiklerden yüksektir'] },
      { k: ['ipek'], ad: 'İpek', m: 'En ince ve en parlak doğal liftir; ışığa göre renk değiştiren zarif bir görünüm verir ve çok ince desen işlemeye uygundur.', arti: ['Eşsiz parlaklık ve ince işçilik', 'Uzun ömürlü olabilir'], dikkat: ['Hassastır; yoğun kullanımda ve nemde yıpranabilir', 'Fiyatı en yüksek liflerdendir'] },
      { k: ['viskon'], ad: 'Viskon', m: 'Bitki selülozundan (odun hamurundan) elde edilen yarı yapay bir liftir; ipeğe benzer parlaklık ve akışkan bir doku verir.', arti: ['İpeksi görünüm, daha uygun fiyat'], dikkat: ['Islanınca zayıflar; sıvı dökülürse hemen kurulayın', 'Yoğun kullanımda ezilip parlaklığını kaybedebilir'] },
      { k: ['modal', 'tencel'], ad: 'Modal / Tencel', m: 'Odun selülozundan üretilen yumuşak, ipeksi tuşeli bir liftir. Viskon ailesindendir ama ıslakken viskondan daha dayanıklıdır.', arti: ['Çok yumuşak ve ipeksi his', 'Parlak ve şık görünüm'], dikkat: ['Yine de neme ve ağır kullanıma karşı sentetikler kadar dayanıklı değildir'] },
      { k: ['bambu'], ad: 'Bambu ipliği', m: 'Bambu bitkisinin selülozundan elde edilen ipeksi parlaklıkta bir iplik türüdür (viskon ailesindendir).', arti: ['İpeğe yakın parlaklık ve yumuşak dokunuş'], dikkat: ['Neme hassastır: sıvı dökülürse hemen kurulayın, ıslak bırakmayın'] },
      { k: ['jüt'], ad: 'Jüt', m: 'Jüt bitkisinden elde edilen doğal bir liftir; hasır benzeri, doğal ve sade bir görünüm verir.', arti: ['Doğal, sıcak ve rustik görünüm'], dikkat: ['Dokusu serttir; neme hassastır'] },
      { k: ['deri'], ad: 'Doğal deri', m: 'Hayvan derisinden yapılır; her parçanın renk ve desen geçişi farklıdır, bu yüzden hiçbiri birebir aynı değildir.', arti: ['Dayanıklı ve benzersiz görünüm'], dikkat: ['Neme ve uzun süreli güneşe karşı korunmalıdır'] }
    ],
    taban: [
      { k: ['pamuk'], ad: 'Pamuk taban', m: 'Halının arka katmanının pamuk iplikten oluşması demektir. Pamuk doğal bir liftir; taban formunu iyi korur, nefes alır ve halının düz durmasına yardım eder.' },
      { k: ['çözgü', 'atkı'], ad: 'Çözgü ve atkı', m: 'Dokumanın iskeletini oluşturan boyuna (çözgü) ve enine (atkı) iplerdir. Üzerlerine yüzey ipliği işlenir; taban ipliği ne kadar sağlamsa halı o kadar dengeli durur.' },
      { k: ['kumaş', 'keçe'], ad: 'Kumaş / keçe taban', m: 'Halının arkasına yumuşak bir kumaş ya da keçe katman eklenmesidir; halının yerinde durmasına ve zemine temas eden yüzeyin yumuşak olmasına yardım eder.' },
      { k: ['jüt'], ad: 'Jüt taban', m: 'Tabanın jüt bitkisinden yapıldığı anlamına gelir; doğal ve sağlam bir tabandır, ancak neme karşı hassastır.' },
      { k: ['kaymaz', 'kaydırmaz'], ad: 'Kaymaz özellik', m: 'Taban, halının zeminde kaymasını azaltacak şekilde hazırlanmıştır. Bu, özellikle hareketli alanlarda ve parkede işe yarar.' }
    ],
    dokuma: [
      { k: ['makine'], ad: 'Makine dokuma', m: 'Halı tezgâhlarında makineyle dokunur. Düzgün, sık ve her parçası aynı olan halılar ortaya çıkar; üretimi hızlıdır, fiyatı daha ulaşılabilirdir.' },
      { k: ['bukle'], ad: 'Bukle tipi', m: 'Yüzeyi ilmekli (kıvırcık) dokulu halı türüdür; hav yüksekliğine göre ilmekler halıya dolgun bir görünüm verir.' },
      { k: ['el dokuma'], ad: 'El dokuma', m: 'Usta dokumacıların tezgâhta düğüm düğüm işlediği halılardır. Üretimi uzun sürer; her halı biraz farklıdır ve bu fark doğaldır. Çok uzun ömürlüdür, fiyatı daha yüksektir.' },
      { k: ['patchwork'], ad: 'El yapımı patchwork', m: 'Farklı halı ya da deri parçalarının elle bir araya getirilmesiyle yapılır. Her halı tektir; desen ve renk dağılımı birebir aynı olmaz.' }
    ],
    sacak: [
      { k: ['spor'], ad: 'Spor saçak', m: 'Kısa ve sade bir saçaktır; halıya düzgün, çağdaş bir çizgi verir ve kolay bakım sağlar. "Düz" ve "kısa" ifadeleri saçağın kesimini ve boyunu belirtir.' },
      { k: ['örgü'], ad: 'Örgü saçak', m: 'Saçak iplerinin örülerek bağlandığı dekoratif bir bitiştir; dokunun uçtan çözülmesini de engeller.' },
      { k: ['düğüm'], ad: 'Düğüm saçak', m: 'Saçak ipleri tek tek düğümlenerek sabitlenir; sağlam ve geleneksel bir bitiştir.' },
      { k: ['püskül'], ad: 'Püskül saçak', m: 'Saçaklar demetler hâlinde püskül biçiminde toplanır; yumuşak ve süslü bir görünüm verir.' },
      { k: ['ipek'], ad: 'İpek saçak', m: 'Saçağın ipekten yapıldığı anlamına gelir; parlak ve zarif görünür, hassastır.' },
      { k: ['yün'], ad: 'Yün saçak', m: 'Saçağın yün iplikle yapıldığı anlamına gelir; doğal ve dayanıklıdır.' },
      { k: ['düz'], ad: 'Düz saçak', m: 'Saçak iplerinin düz biçimde bırakıldığı klasik bir saçaktır.' },
      { k: ['saçaksız', 'overlok', 'kenar dikişli'], ad: 'Saçaksız / kenar dikişli', m: 'Halının kenarı dikişle kapatılmıştır (overlok). Takılma riski olmaz; sade ve modern görünür, robot süpürge için pratiktir.' }
    ]
  };

  var WA = '905443814458';

  /* ---------------- Yardımcılar ---------------- */

  function kucuk(s) { return String(s || '').toLocaleLowerCase('tr').replace(/\s+/g, ' ').trim(); }
  function el(etiket, sinif, metin) {
    var e = document.createElement(etiket);
    if (sinif) e.className = sinif;
    if (metin != null) e.textContent = metin;
    return e;
  }

  var ETIKET_ALAN = {};
  Object.keys(ALANLAR).forEach(function (a) { ALANLAR[a].etiketler.forEach(function (t) { ETIKET_ALAN[t] = a; }); });

  function degerKartlari(alan, deger) {
    var liste = DEGERLER[alan];
    if (!liste) return [];
    var d = kucuk(deger).replace(/yün tuşeli/g, ''); // "Yün Tuşeli Akrilik" yün değildir
    d = d.replace(/polyester jüt/g, 'polyester'); // "Polyester Jüt": tek iplik türü (polyester), ayrı jüt lifi değil
    var duz = d; // parantez içi açıklama (ör. "Şönil İplik (Polyester)") ayrı bir karışım sayılmaz
    if (alan === 'sacak') d = d.replace(/\([^)]*\)/g, ''); // (Düz) / (Kısa) açıklayıcı ek: ayrı saçak türü sayılmaz
    var sonuc = [];
    var lifler = 0;
    liste.forEach(function (k) {
      if (k.oz === 'karisim') return;
      if (k.k.some(function (a) { return d.indexOf(a) > -1; })) { sonuc.push(k); lifler++; }
    });
    if (alan === 'iplik') {
      var karisim = liste[0];
      var parantezsiz = duz.replace(/\([^)]*\)/g, '');
      var ayrac = /( - |, | ve |&|\/)/.test(parantezsiz);
      var karisikMi = /%\s*\d+.*%\s*\d+/.test(duz) || duz.indexOf('karışım') > -1 || (lifler > 1 && ayrac);
      if (karisikMi) sonuc.unshift(karisim);
    }
    return sonuc.slice(0, 4);
  }

  function sayilar(deger) {
    var m = String(deger).match(/(\d[\d.,]*)/);
    if (!m) return null;
    return parseFloat(m[1].replace(/\./g, '').replace(',', '.'));
  }

  /* ---------------- Pencere ---------------- */

  var dlg = null;
  var kokOverflow = '';

  function bolum(baslik, govde) {
    var b = el('section', 'naar-oza__bolum');
    if (baslik) b.appendChild(el('h3', 'naar-oza__altbaslik', baslik));
    govde.forEach(function (g) { b.appendChild(g); });
    return b;
  }
  function liste(maddeler) {
    var ul = el('ul', 'naar-oza__liste');
    maddeler.forEach(function (x) {
      var li = el('li');
      if (x.b) li.appendChild(el('strong', null, x.b + ' '));
      li.appendChild(document.createTextNode(x.m));
      ul.appendChild(li);
    });
    return ul;
  }

  function icerikOlustur(anahtar, etiket, deger) {
    var a = ALANLAR[anahtar];
    var kok = document.createDocumentFragment();

    var vur = el('p', 'naar-oza__deger');
    vur.appendChild(el('span', null, 'Bu halıda: '));
    vur.appendChild(el('strong', null, deger));
    kok.appendChild(vur);

    kok.appendChild(el('p', 'naar-oza__nedir', a.nedir));

    // Hav yüksekliği: değere göre grup vurgusu
    var vurguId = null;
    if (anahtar === 'hav') {
      var mm = sayilar(deger);
      if (mm != null) {
        vurguId = mm <= 10 ? 'kisa' : (mm <= 20 ? 'orta' : 'uzun');
        var ad = vurguId === 'kisa' ? 'kısa hav' : (vurguId === 'orta' ? 'orta hav' : 'uzun hav');
        kok.appendChild(el('p', 'naar-oza__not-vurgu', 'Bu halının hav yüksekliği ' + deger + ': ' + ad + ' grubunda.'));
      }
    }
    if (a.gruplar) {
      var gl = el('div', 'naar-oza__gruplar');
      a.gruplar.forEach(function (g) {
        var kart = el('div', 'naar-oza__grup' + (g.id === vurguId ? ' naar-oza__grup--secili' : ''));
        kart.appendChild(el('strong', null, g.b));
        kart.appendChild(el('p', null, g.m));
        if (g.id === vurguId) kart.appendChild(el('span', 'naar-oza__rozet', 'Bu halı'));
        gl.appendChild(kart);
      });
      kok.appendChild(bolum(a.baslik, [gl]));
    }

    // Değere özgü kartlar
    var kartlar = degerKartlari(anahtar, deger);
    if (kartlar.length) {
      var kapsayici = el('div', 'naar-oza__kartlar');
      kartlar.forEach(function (k) {
        var c = el('div', 'naar-oza__kart');
        c.appendChild(el('h4', null, k.ad));
        c.appendChild(el('p', null, k.m));
        if (k.arti && k.arti.length) {
          var u1 = el('ul', 'naar-oza__arti');
          k.arti.forEach(function (x) { u1.appendChild(el('li', null, x)); });
          c.appendChild(u1);
        }
        if (k.dikkat && k.dikkat.length) {
          var u2 = el('ul', 'naar-oza__dikkat');
          k.dikkat.forEach(function (x) { u2.appendChild(el('li', null, x)); });
          c.appendChild(u2);
        }
        kapsayici.appendChild(c);
      });
      kok.appendChild(bolum('"' + deger + '" ne demek?', [kapsayici]));
    }

    if (a.maddeler) {
      var govde = [];
      if (a.giris) govde.push(el('p', 'naar-oza__giris', a.giris));
      govde.push(liste(a.maddeler));
      kok.appendChild(bolum(a.baslik, govde));
    }
    if (a.dipnot) kok.appendChild(el('p', 'naar-oza__dipnot', a.dipnot));
    return kok;
  }

  function olustur() {
    dlg = document.createElement('dialog');
    dlg.className = 'naar-oza';
    dlg.setAttribute('aria-labelledby', 'naar-oza-baslik');
    var ic = el('div', 'naar-oza__ic');
    var ust = el('div', 'naar-oza__ust');
    var baslik = el('h2', 'naar-oza__baslik');
    baslik.id = 'naar-oza-baslik';
    baslik.tabIndex = -1;
    baslik.setAttribute('autofocus', ''); // açılınca odak başlığa gelir (kapat düğmesinde odak halkası görünmesin)
    var kapat = el('button', 'naar-oza__kapat');
    kapat.type = 'button';
    kapat.setAttribute('aria-label', 'Kapat');
    kapat.innerHTML = '<svg width="16" height="16" viewBox="0 0 18 18" aria-hidden="true" focusable="false"><path d="M3 3l12 12M15 3L3 15" stroke="currentColor" stroke-width="2" stroke-linecap="round" fill="none"/></svg>';
    ust.appendChild(baslik); ust.appendChild(kapat);
    var govde = el('div', 'naar-oza__govde');
    var alt = el('div', 'naar-oza__alt');
    ic.appendChild(ust); ic.appendChild(govde); ic.appendChild(alt);
    dlg.appendChild(ic);
    document.body.appendChild(dlg);
    dlg.addEventListener('click', function (e) {
      if (e.target === dlg || (e.target.closest && e.target.closest('.naar-oza__kapat, .naar-oza__tamam'))) dlg.close();
    });
    dlg.addEventListener('close', function () { document.documentElement.style.overflow = kokOverflow; });
  }

  function ac(anahtar, etiket, deger) {
    if (typeof HTMLDialogElement === 'undefined') return;
    if (!dlg) olustur();
    dlg.querySelector('.naar-oza__baslik').textContent = ALANLAR[anahtar].ad;
    var govde = dlg.querySelector('.naar-oza__govde');
    govde.textContent = '';
    govde.appendChild(icerikOlustur(anahtar, etiket, deger));
    var alt = dlg.querySelector('.naar-oza__alt');
    alt.textContent = '';
    var urun = (document.querySelector('h1') || {}).textContent || document.title;
    var mesaj = 'Merhaba, ' + String(urun).trim() + ' ürünündeki "' + etiket + ': ' + deger + '" hakkında bilgi almak istiyorum.';
    var wa = el('a', 'naar-oza__wa', 'WhatsApp\'tan sor');
    wa.href = 'https://wa.me/' + WA + '?text=' + encodeURIComponent(mesaj);
    wa.target = '_blank'; wa.rel = 'noopener';
    var tamam = el('button', 'naar-oza__tamam', 'Anladım');
    tamam.type = 'button';
    alt.appendChild(wa); alt.appendChild(tamam);
    govde.scrollTop = 0;
    kokOverflow = document.documentElement.style.overflow;
    document.documentElement.style.overflow = 'hidden';
    try { dlg.showModal(); } catch (e) { dlg.setAttribute('open', ''); }
  }

  /* ---------------- Satırları düğmeye çevir ---------------- */

  function kur() {
    var kutu = document.querySelector('.naar-sk__tablo');
    if (!kutu || kutu.dataset.ozaHazir) return;
    kutu.dataset.ozaHazir = '1';
    var sayac = 0;
    kutu.querySelectorAll('li').forEach(function (li) {
      var guclu = li.querySelector('strong');
      if (!guclu) return;
      var etiket = guclu.textContent.replace(/:\s*$/, '').trim();
      var anahtar = ETIKET_ALAN[kucuk(etiket)];
      if (!anahtar) return;
      var deger = li.textContent.replace(guclu.textContent, '').trim();
      if (!deger) return;
      var d = el('button', 'naar-oza-satir');
      d.type = 'button';
      d.setAttribute('aria-haspopup', 'dialog');
      d.setAttribute('aria-label', etiket + ': ' + deger + '. Açıklamayı göster');
      d.appendChild(el('span', 'naar-oza-etiket', etiket + ':'));
      d.appendChild(el('span', 'naar-oza-deger', deger));
      var i = el('span', 'naar-oza-i', 'i');
      i.setAttribute('aria-hidden', 'true');
      d.appendChild(i);
      d.addEventListener('click', function () { ac(anahtar, etiket, deger); });
      li.textContent = '';
      li.appendChild(d);
      sayac++;
    });
    if (sayac) {
      var ipucu = el('p', 'naar-oza-ipucu', 'Bir özelliğe dokunarak ne anlama geldiğini görebilirsiniz.');
      kutu.insertBefore(ipucu, kutu.firstChild);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', kur); else kur();
  document.addEventListener('shopify:section:load', kur);
})();
